module.exports = __webpack_public_path__ + "static/media/superhero.a9607895.svg";